// Der Ressourcenkonverter, so weit er ohne DOM zu beschreiben ist.
//
// Er liegt neben dem Panel statt darin, aus demselben Grund wie `help.ts`:
// eine reine Funktion ist ohne Browser pruefbar, und es gibt bewusst kein
// jsdom (`.claude/rules/harness.md`).
//
// Der Anlass war ein Fehler, der nach „der Server kommt nicht mit" aussah. Der
// Aenderungsschluessel der Liste enthielt **jede gefloorte Ressourcenzahl**;
// der Panel-Takt laeuft im `requestAnimationFrame`, und solange die Drohnen
// graben, aendert sich so eine Zahl mehrmals pro Sekunde. Die Liste wurde also
// dauernd per `innerHTML` neu gebaut — und ein Klick, dessen Druck und
// Loslassen ein Rerender trennt, feuert nie. Der Knopf wurde dem Spieler unter
// dem Finger weggezogen.
//
// Der Schluessel bildet deshalb ab, **was die Liste zeigt**, nicht **woraus
// sie es rechnet**: welche Rezepte offen sind und welcher Kostenposten gedeckt
// ist. Beides sind Schwellen, und Schwellen fallen selten.

import { recipes } from '../data/balancing';
import { builtIds } from '../sim/stats';
import type { Recipe } from '../data/types';
import { deckung } from './listkeys';

/**
 * Die Rezepte, deren Ausbaustufe steht.
 *
 * Der Konverter erscheint erst mit der Stufe, die ihn traegt — er steht unter
 * dem Ausbau, weil er einer ist.
 */
export function openRecipes(built: number): Recipe[] {
  const gebaut = builtIds(built);
  return recipes().filter((entry) => gebaut.has(entry.needBuild));
}

/**
 * Der Aenderungsschluessel der Konverterliste.
 *
 * Ein Bit je Kostenposten — die Rechnung dafuer steht als `deckung` in
 * `listkeys.ts`, wo dieselbe Regel fuer Ausbau-, Booster- und Auftragsliste
 * gilt. Sie stand hier einmal zeichengleich daneben; zwei Fassungen derselben
 * Regel sind das, wogegen dieses Projekt sonst Gates baut.
 */
export function recipeListKey(
  offen: readonly Recipe[],
  res: Readonly<Record<string, number>>,
): string {
  return offen.map((entry) => `${entry.id}:${deckung(entry.inputs, res)}`).join('|');
}

// Wie viele Durchlaeufe der Vorrat deckt, steht **nicht** hier, sondern als
// `affordableRuns` in `sim/stats.ts`. Das ist keine Ansicht, sondern eine
// Regel — und `net/moves.ts` (Schicht 4) braucht sie genauso wie das Panel
// (Schicht 5). Sie hier zu halten waere ein Import nach oben (Gate FG-04);
// eine Zeile tiefer liegt sie neben der Freischalt- und Kostenlogik, die aus
// demselben Grund dort liegt.
